/* eslint-disable no-dupe-keys */
export default {
  app_page: {
    name: 'App跳转页',
    // 属性（一般与对象内容匹配）
    prop: {
      page_name: '页面名',
      android_page: '安卓跳转页',
      miniprogram_page: '小程序跳转页',
      ios_page: 'iOS跳转页',
      ios_page_storyboard: 'iOS故事版',
      page_url: '网页跳转地址'
    },
    // 列表页字段（列控制使用，需要与列表页匹配）
    columns: {
      page_name: '页面名',
      android_page: '安卓跳转页',
      miniprogram_page: '小程序跳转页',
      ios_page: 'iOS跳转页',
      ios_page_storyboard: 'iOS故事版',
      page_url: '网页跳转地址',
      created_at: '创建时间',
      updated_at: '更新时间',
      page_content: '跳转页内容'
    },
    // Enum的属性
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '页面名'
    },
    // 详情页标签
    update_title: '更新APP跳转页',
    create_title: '创建APP跳转页'
  }
}
